import React, { Component } from 'react';
import Image from './../../images/Recykle.png';
import { connect } from 'react-redux';
import { logout } from './../../actions/Auth/UserLoginCheck';
import { Collapse, Card, Navbar, NavbarToggler, Nav, NavItem, Button, UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import { Link } from 'react-router';
import '../../index.css';

class Header extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    logoutButtonPress() {
        const { users } = this.props;
        this.props.logout({ users });
    }

    render() {
        const { users } = this.props;
        return (
            <Card style={styles.headerStyle}>
                <Navbar light expand="xl">
                    <Link to="/Dashboard">
                        <div className="row">
                            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                <img
                                    src={Image}
                                    className="img-responsive"
                                    style={{ width: 40, height: 40 }}
                                />
                            </div>
                        </div>
                    </Link>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav navbar style={{ paddingLeft: 20 }}>
                            <NavItem style={{ width: 115 }}>
                                <Link tag={Link} activeClassName="active" to="/Dashboard" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Dashboard
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 100 }}>
                                <Link tag={Link} activeClassName="active" to="/Articles" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                       Articles
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 90 }}>
                                <Link tag={Link} activeClassName="active" to="/Events" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Events
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 100 }}>
                                <Link tag={Link} activeClassName="active" to="/Products" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Products
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 85 }}>
                                <Link tag={Link} activeClassName="active" to="/Chat" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Chat
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 90 }}>
                                <Link tag={Link} activeClassName="active" to="/UserDetails" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Users
                                    </span>
                                </Link>
                            </NavItem>
                            <NavItem style={{ width: 100 }}>
                                <Link tag={Link} activeClassName="active" to="/Campaign" style={styles.textDecorationStyle}>
                                    <span style={styles.textStyle}>
                                        Campaign
                                    </span>
                                </Link>
                            </NavItem>
                        </Nav>
                        <Nav className="ml-auto" navbar style={{ width: 300, paddingTop: 3, justifyContent: 'flex-end' }}>
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    <span style={styles.textStyle}>
                                        <i className="fa fa-user" aria-hidden="true" style={{ fontSize: 17, paddingRight: 5 }} />
                                            Welcome {users.name}
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem style={styles.dropdownStyle}>
                                        <Button
                                            style={styles.buttonStyle}
                                            onClick={() => { this.logoutButtonPress(); }}
                                        >
                                            <i className="fa fa-sign-out" aria-hidden="true" style={{ fontSize: 17 }} />
                                            <span style={styles.logoutStyle}>
                                                 Log out
                                            </span>
                                        </Button>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                </Navbar>
            </Card>
        );
    }
}

const styles = {
    headerStyle: {
        borderRadius: 0,
        backgroundColor: '#44B31F',
        boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)`
    },
    textDecorationStyle: {
        textDecoration: 'none'
    },
    textStyle: {
        color: '#fff',
        fontFamily: 'Source Sans Pro-SemiBold',
        marginBottom: 5
    },
    dropdownStyle: {
        textDecoration: 'none',
        backgroundColor: '#fff',
        outlineWidth: 0
    },
    buttonStyle: {
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    logoutStyle: {
        fontSize: 16,
        paddingLeft: 3,
        fontFamily: 'Source Sans Pro-SemiBold'
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user
    };
}

export default connect(mapStateToProps, { logout })(Header);



// WEBPACK FOOTER //
// ./src/components/common/Header.js